import { IonItem, IonLabel, IonText } from '@ionic/react'
import { isEmpty } from 'lodash'
import { PLACEHOLDER } from 'helpers/utils'
import { t } from 'helpers/i18n'
import { createListViewComponent } from 'factories/ListView'
import { getPrivateItem } from 'helpers/localForage'
import { ISSUED_ITEMS_SAVED_KEY } from 'options/inventory/issue'
import { showError } from 'helpers/errors'
import Filter from 'containers/Issue/ReviewItems/Filter'

export default createListViewComponent({
  getStorageKey: () => 'inventory.issue.reviewItems',
  renderItem:
    ({ props, state, updateState, fetchItems }) =>
    (each) => (
      <IonItem key={each.id} lines="full" routerLink={`${props.match.url}/${each.id}`}>
        <IonLabel>
          {props.useInventoryBarcode ? each.inventoryBarcode || each.barcode : each.barcode}
          <br />
          <IonText color="medium">
            <small>
              {each.description || PLACEHOLDER}
              <br />
              {each.locationName}, {t('issued:')} {each.quantityIssued}
            </small>
          </IonText>
        </IonLabel>
      </IonItem>
    ),
  allowInfiniteLoader: () => false,
  getViewDidEnterHandler:
    ({ props, updateState }) =>
    async () => {
      try {
        const items = await getPrivateItem(ISSUED_ITEMS_SAVED_KEY, [])

        if (isEmpty(items)) {
          updateState((draft) => {
            draft.alertIsOpen = true
            draft.alertMessage = t('nothingToReview')
            draft.alertButtons = [
              {
                text: t('ok'),
                role: 'cancel',
                handler: () => props.history.goBack(),
              },
            ]
          })
        }
      } catch (error) {
        showError({ error })
      }
    },
  allowDelete: (self) => (item) => true,
  allowSearch: (self) => true,
  getSortByFields: (self) => [
    {
      fieldName: self.props.useInventoryBarcode ? 'inventoryBarcode' : 'barcode',
      languageKey: 'barcode',
    },
    { fieldName: 'description', languageKey: 'description' },
    { fieldName: 'locationName', languageKey: 'location' },
    { fieldName: 'quantityIssued', languageKey: 'quantityIssued' },
  ],
})(Filter)
